export enum DashboardWidget {
  PIE = 'pie',
  BAR = 'bar',
  LINE = 'line',
  SUMMARY = 'summary',
}
